import WrlGuide from './WrlGuide';

export default WrlGuide;
